import { gql } from '@apollo/client'

export const KUSTOMER_ARTICLES = gql`
  query kustomerArticles {
    kustomerArticles {
      articles {
        id
        latestVersionId
        title
        category
      }
    }
  }
`
